import React from "react";
import ManImage from "../Images/contactCardMen.png";
import { Link } from "react-router-dom";
import {  FaPaperPlane } from "react-icons/fa";

export default function ContactCard() {
  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-75 py-5 contact-card">
      <div
        className="card w-100 shadow-lg border-0 rounded-5 overflow-hidden text-light  "
      >
        <div className="row g-0 align-items-stretch bg-navyblue">
          {/* Left: Image */}
          <div className="col-12 col-md-6">
            <img
              src={ManImage}
              alt="Contact Visual"
              className="img-fluid contact-image"
              style={{maxHeight:"500px"}}
            />
          </div>

          {/* Right: Content */}
          <div className="col-12 col-md-6 d-flex flex-column justify-content-start align-items-start p-4 text-start">
            <div className="mb-2">
              <span className="badge bg-white text-dark fw-semibold px-3 py-2 shadow-sm fs-6 rounded">
                <FaPaperPlane className="me-2" />
                CONTACT US
              </span>
            </div>
            <p className="fw-bold mb-2 fs-1" style={{ fontFamily: "Cardo" }}>
              Want to transform your IT strategy into a competitive edge?
            </p>
            <p className="mb-4 fs-4">
              Our team of experts helps you streamline operations, secure your data,
              and deliver real impact—faster. Whether you're starting fresh or
              upgrading legacy systems, DeepIT Consulting is here to guide your next
              big leap.
            </p>
            <Link to="/contact" className="rounded-5 px-4 py-2 bg-white text-navyblue border-navyblue text-decoration-none">
              Get in Touch →
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}
